import { render, staticRenderFns } from "./RirekishoEdit.vue?vue&type=template&id=55170ae0&scoped=true&"
import script from "./RirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./RirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RirekishoEdit.vue?vue&type=style&index=0&id=55170ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55170ae0",
  null
  
)

export default component.exports